import { Center, Image, Stack, Text } from '@mantine/core';

import { MENU_EMPTY_IMAGE_SRC } from '../constants';

type MenuEmptyStateProps = {
  title: string;
  description?: string;
};

export const MenuEmptyState: React.FC<MenuEmptyStateProps> = ({ title, description }) => (
  <Center h="70%" mih={200}>
    <Stack align="center" gap="xs">
      <Image src={MENU_EMPTY_IMAGE_SRC} alt="" w={120} h={120} fit="contain" />
      <Text fw={700} ta="center">
        {title}
      </Text>
      {description && (
        <Text size="sm" c="dimmed" ta="center">
          {description}
        </Text>
      )}
    </Stack>
  </Center>
);
